// 投顾相关路由
export const investment = [
  {
    path: '/investment-advisor/product-list',
    name: 'InvestmentProductList',
    meta: {
      title: '投顾管家'
    },
    component: () => import('../views/investment-advisor/product-list.vue')
  },
  {
    path: '/investment-advisor/invest-guanjia',
    name: 'InvestmentGuanjia',
    meta: {
      title: '投顾管家'
    },
    component: () => import('../views/investment-advisor/invest-guanjia.vue')
  },
  {
    path: '/investment-advisor/kyc-question',
    name: 'InvestmentKYC',
    meta: {
      title: '普泽基金'
    },
    component: () => import('../views/investment-advisor/kyc-question.vue')
  },
  {
    path: '/investment-advisor/kyc-result',
    name: 'InvestmentKYCResult',
    meta: {
      title: '普泽基金'
    },
    component: () => import('../views/investment-advisor/kyc-result.vue')
  },
  {
    path: '/investment-advisor/invest-detail',
    name: 'InvestmentDetail',
    meta: {
      title: '策略详情'
    },
    component: () => import('../views/investment-advisor/invest-detail.vue')
  },
  {
    path: '/investment-advisor/invest-report',
    name: 'InvestmentReport',
    meta: {
      title: '投顾报告'
    },
    component: () => import('../views/investment-advisor/invest-report.vue')
  },
  {
    path: '/investment-advisor/invest-mance',
    redirect: {
      name: 'InvestmenStage'
    },
    name: 'InvestmentMance',
    meta: {
      title: '投顾业绩'
    },
    component: () => import('../views/investment-advisor/invest-mance.vue'),
    children: [
      {
        path: 'invest-day-dhc',
        name: 'InvestmenDayDhc',
        meta: {
          title: '投顾业绩'
        },
        component: () => import('../views/investment-advisor/invest-day-dhc.vue')
      },
      {
        path: 'invest-stage',
        name: 'InvestmenStage',
        meta: {
          title: '投顾业绩'
        },
        component: () => import('../views/investment-advisor/invest-stage.vue')
      },
      {
        path: 'invest-year-mance',
        name: 'InvestmenYearMance',
        meta: {
          title: '投顾业绩'
        },
        component: () => import('../views/investment-advisor/invest-year-mance.vue')
      }
    ]
  },
  {
    path: '/investment-advisor/invest-asset-config',
    redirect: {
      name: 'InvestmenHold'
    },
    name: 'InvestmenAssetConfig',
    meta: {
      title: '资产配置'
    },
    component: () => import('../views/investment-advisor/invest-asset-config.vue'),
    children: [
      {
        path: 'invest-hold',
        name: 'InvestmenHold',
        meta: {
          title: '资产配置'
        },
        component: () => import('../views/investment-advisor/invest-hold.vue')
      },
      {
        path: 'invest-change',
        name: 'InvestmenChange',
        meta: {
          title: '资产配置'
        },
        component: () => import('../views/investment-advisor/invest-change.vue')
      }
    ]
  },
  {
    path: '/investment-advisor/invest-archive',
    name: 'InvestmentArchive',
    meta: {
      title: '投顾档案'
    },
    component: () => import('../views/investment-advisor/invest-archive.vue')
  },
  {
    path: '/investment-advisor/trade-rule',
    name: 'InvestmentTradeRule',
    meta: {
      title: '交易规则'
    },
    component: () => import('../views/investment-advisor/trade-rule.vue')
  },
  {
    path: '/investment-advisor/invest-question',
    name: 'InvestmentQuestion',
    meta: {
      title: '常见问题'
    },
    component: () => import('../views/investment-advisor/invest-question.vue')
  },
  {
    path: '/invest-risk-warning',
    name: 'InvestAdviseRiskWarning',
    component: () => import('../views/investment-advisor/invest-risk-warning.vue'),
    meta: {
      title: '风险揭示书'
    }
  },
  {
    path: '/investment-advisor/invest-buy',
    name: 'InvestMentBuy',
    component: () => import('../views/investment-advisor/invest-buy.vue'),
    meta: {
      title: '转入'
    }
  },
  {
    path: '/investment-advisor/buy-result',
    name: 'InvestMentBuyResult',
    component: () => import('../views/investment-advisor/trade-result/buy-result.vue'),
    meta: {
      title: '转入'
    }
  },
  {
    path: '/investment-advisor/invest-sell',
    name: 'InvestMentSell',
    component: () => import('../views/investment-advisor/invest-sell.vue'),
    meta: {
      title: '转出'
    }
  },
  {
    path: '/investment-advisor/sell-result',
    name: 'InvestMentSellResult',
    component: () => import('../views/investment-advisor/trade-result/sell-result.vue'),
    meta: {
      title: '转出'
    }
  },
  {
    path: '/investment-advisor/hold-position',
    name: 'InvestmentHoldPosition',
    meta: {
      title: '投顾'
    },
    component: () => import('../views/investment-advisor/hold-position.vue')
  },
  {
    path: '/investment-advisor/trade-records',
    name: 'InvestmentTradeRecords',
    meta: {
      title: '交易记录'
    },
    component: () => import('../views/investment-advisor/trade-records.vue')
  },
  {
    path: '/investment-advisor/hold-detail',
    name: 'InvestmentHoldDetail',
    meta: {
      title: '持仓详情'
    },
    component: () => import('../views/investment-advisor/hold-detail.vue')
  },
  {
    path: '/investment-advisor/income-detail',
    name: 'InvestmentIncomeDetail',
    meta: {
      title: '收益明细'
    },
    component: () => import('../views/investment-advisor/income-detail.vue')
  },
  {
    path: '/investment-advisor/trade-detail-sell',
    name: 'InvestmentTradeDetailSell',
    meta: {
      title: '交易详情'
    },
    component: () => import('../views/investment-advisor/trade-result/sell-out.vue')
  },
  {
    path: '/investment-advisor/trade-detail-purchase',
    name: 'InvestmentTradeDetailPurchase',
    meta: {
      title: '交易详情'
    },
    component: () => import('../views/investment-advisor/trade-result/purchase.vue')
  },
  {
    path: '/investment-advisor/trade-detail-bonus',
    name: 'InvestmentTradeDetailBonus',
    meta: {
      title: '交易详情'
    },
    component: () => import('../views/investment-advisor/trade-result/bonus.vue')
  },
  {
    path: '/investment-advisor/trade-detail-increases',
    name: 'InvestmentTradeDetailIncreases',
    meta: {
      title: '交易详情'
    },
    component: () => import('../views/investment-advisor/trade-result/increase-reduce.vue')
  },
  {
    path: '/investment-advisor/trade-detail-redemption',
    name: 'InvestmentTradeDetailRedemption',
    meta: {
      title: '交易详情'
    },
    component: () => import('../views/investment-advisor/trade-result/redemption.vue')
  },
  {
    path: '/investment-advisor/trade-detail-adjustment',
    name: 'InvestmentTradeDetailAdjustment',
    meta: {
      title: '交易详情'
    },
    component: () => import('../views/investment-advisor/trade-result/adjustment.vue')
  },
  {
    path: '/investment-advisor/trade-detail-fee',
    name: 'InvestmentTradeDetailFees',
    meta: {
      title: '交易详情'
    },
    component: () => import('../views/investment-advisor/trade-result/invest-fee.vue')
  }
]
